import request from '@/service/api'
import ConfigType from '@/service/api/type'
import qs from 'qs'
enum DocumentsApi {
    // 单据调拨
    TransferOrder = '/TransferOrder/Page',//单据调拨查询   
    AddTransferOrder = '/TransferOrder/AddTransferOrder',//单据调拨新增 
    AddTransdepartment = '/TransferOrder/department',//查询ERP部门
    GetCMSMQ = '/TransferOrder/GetCMSMQ',//查询ERP调拨单别
    TransferOrderPush = '/TransferOrder/push',//根据ID推送调拨单   
    AddTransferOrderDetails = '/TransferOrder/AddTransferOrderDetails',//新增单据明细调拨   
    TransferOrderprint = '/TransferOrder/TransferPrint',//调拨单打印   
    TransferOrderDetails = '/TransferOrder/TransferOrderDetails',//根据ID查找调拨单明细   
    GetProjectCode = '/TransferOrder/GetProjectCode',//项目号模糊查询   
    GetLocationCode = '/TransferOrder/GetLocationCode',//转入库位模糊查询   
    deleteOutDataPage = '/TransferOrder/DeleteTransferOrder',//删除
    StockListPage = '/TransferOrder/StockListPage', //分页查询库存
    InsertTransferOrder = '/TransferOrder/InsertTransferOrder', //主明细一起新增
    ImportMaterial = '/TransferOrder/ImportMaterial', //主明细一起新增
    TransferExecute = '/TransferOrder/TransferExecute', //主明细一起执行
    AddPrintQuantity = '/TransferOrder/AddPrintQuantity', //主明细一起打印次数
    returnStockListPage= '/TransferOrder/MaterialListPage', //分页查询库存
    AddInsertTransferOrder = '/TransferOrder/AddInsertTransferOrder', //新增
    //UpdateTransferOrderDetails = '/TransferOrder/UpdateTransferOrderDetails', //修改
    // 黑库调拨单
    BlackPage='/TransferOrder/BlackPage',  // 黑库调拨单分页查询
    BlackStockListPage='/TransferOrder/BlackStockListPage', // 黑库库存分页查询
    InsertBlackTransferOrder='/TransferOrder/InsertBlackTransferOrder', //新增黑库调拨单
    AddBlackTransferOrderDetails='/TransferOrder/AddBlackTransferOrderDetails',  // 修改黑库调拨单明细

    // 图片上传
    TransferOrderImagesUpload='/TransferOrder/TransferOrderImagesUpload' ,  //图片上传
   
    UpdateTransferOrder='/TransferOrder/UpdateTransferOrder',  // 修改黑库调拨单主表
    UpdateTransferOrderDetails='/TransferOrder/UpdateTransferOrderDetails',  // 修改调拨单明细
    
    DeletePKStock = '/TransferOrder/DeletePKStock',//库位调拨
    UpdatePKStock = '/TransferOrder/UpdatePKStock',//项目调拨
}
// 新增
export const UpdateTransferOrder = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.UpdateTransferOrder,
        method: 'post',
        data: data
    })
}
// 新增
// export const UpdateOrderDetails = (data: any): ConfigType<any> => {
//     return request({
//         url: DocumentsApi.UpdateTransferOrderDetails,
//         method: 'post',
//         data: data
//     })
// }


// 分页查询
export const TransferOrder = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.TransferOrder}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 查询明细
export const TransferOrderDetails = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.TransferOrderDetails}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 项目号模糊查询
export const GetProjectCode = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.GetProjectCode}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 转入库位模糊查询
export const GetLocationCode = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.GetLocationCode}?${qs.stringify(data)}`,
        method: 'get'
    })
}

// 新增
export const AddTransferOrder = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.AddTransferOrder,
        method: 'post',
        data: data
    })
}
// 新增
export const AddTransferOrderDetails = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.AddTransferOrderDetails,
        method: 'post',
        data: data
    })
}

// 查询ERP部门
export const AddTransdepartment = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.AddTransdepartment,
        method: 'get',
        data: data
    })
}

// 查询ERP调拨单别
export const GetCMSMQ = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.GetCMSMQ,
        method: 'get',
        data: data
    })
}

// 推送
export const TransferOrderPush = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.TransferOrderPush,
        method: 'post',
        data: data
    })
}
// 调拨单打印
export const TransferOrderprint = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.TransferOrderprint}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 删除
export const deleteOutDataPage = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.deleteOutDataPage,
        method: 'post',
        data: data
    })
}

// 库位调拨
export const DeletePKStock = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.DeletePKStock,
        method: 'post',
        data: data
    })
}

// 项目调拨
export const UpdatePKStock = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.UpdatePKStock,
        method: 'post',
        data: data
    })
}
// 新增
export const AddInsertTransferOrder = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.AddInsertTransferOrder,
        method: 'post',
        data: data
    })
}
// 修改
export const UpdateTransferOrderDetails = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.UpdateTransferOrderDetails,
        method: 'post',
        data: data
    })
}
//分页查询退库库存
export const returnStockListPage = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.returnStockListPage}?${qs.stringify(data)}`,
        method: 'get'
    })
}
//分页查询库存
export const StockListPage = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.StockListPage}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 新增
export const InsertTransferOrder = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.InsertTransferOrder,
        method: 'post',
        data: data
    })
}
//执行
export const TransferExecute = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.TransferExecute,
        method: 'post',
        data: data
    })
}
//执行
export const AddPrintQuantity = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.AddPrintQuantity,
        method: 'post',
        data: data
    })
}

// ******************************黑库调拨单***************************

// 分页查询黑库调拨单
export const BlackPage = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.BlackPage}?${qs.stringify(data)}`,
        method: 'get'
    })
}

// 黑库库存分页查询
export const BlackStockListPage = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.BlackStockListPage}?${qs.stringify(data)}`,
        method: 'get'
    })
}


// 新增黑库调拨单
export const InsertBlackTransferOrder = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.InsertBlackTransferOrder,
        method: 'post',
        data: data
    })
}

// 修改黑库调拨单明细
export const AddBlackTransferOrderDetails = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.AddBlackTransferOrderDetails,
        method: 'post',
        data: data
    })
}

// 图片上传  
export const TransferOrderImagesUpload = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.TransferOrderImagesUpload,
        method: 'post',
        data: data
    })
}